angular.module('workflow.app')
  .controller('StarredDocumentCreateController', require './StarredDocumentCreateController')
